
















import { Component, Vue } from "vue-property-decorator";
import { Feed as IFeed } from "@/interfaces/content";
import { mapState } from "vuex";
import ContentList from "@/components/ContentList.vue";
import i18n from "@/i18n";

@Component({
  computed: {
    ...mapState(["feed"])
  },
  components: {
    ContentList
  }
})
export default class Feed extends Vue {
  // Mapped from Vuex
  feed!: IFeed;

  sections: any[] = [];

  mounted() {
    this.$Progress.set(90);
    const sections = [];
    if (this.feed.featured.length) {
      sections.push({
        title: i18n.t("views.start.featured"),
        data: this.feed.featured
      });
    }
    if (this.feed.new.length) {
      sections.push({
        title: i18n.t("views.start.newVideos"),
        data: this.feed.new
      });
    }
    if (this.feed.recommended.length) {
      sections.push({
        title: i18n.t("views.start.recommended"),
        data: this.feed.recommended
      });
    }

    this.sections = sections;
    this.$Progress.finish();
  }
}
